import React from "react";
import Noticias from "../components/Noticias";

const Menu = () => {
  return (
    <div className="sticky top-[120px] h-fit">
      <section id="noticias">
        <Noticias />
      </section>
    </div>
  );
};

export default Menu;